module.exports = __webpack_public_path__ + "img/block.13447c2c.svg";